import FetchError from '../util/fetch-error';

const selectors = {
  pickupContainer: 'data-store-availability-container',
  shopifySection: '[data-api-content]',
  drawer: '[data-pickup-drawer]',
  drawerOpen: '[data-pickup-drawer-open]',
  drawerClose: '[data-pickup-drawer-close]',
  drawerBody: '[data-pickup-body]',
};

const classes = {
  isVisible: 'drawer--visible',
  isHidden: 'hide',
  isPickupVisible: 'is-pickup-visible',
};

let sections = {};

class PickupAvailability {
  constructor(section) {
    this.container = section.container;
    this.drawer = null;
    this.buttonDrawerOpen = null;
    this.buttonDrawerClose = null;
    this.drawerBody = null;

    this.fetchPickupAvailability();

    this.container.addEventListener('theme:variant:change', (event) => this.fetchPickupAvailability(event));
  }

  fetchPickupAvailability(event) {
    const container = this.container.querySelector(`[${selectors.pickupContainer}]`);
    if (!container) return;
    const variantID = event && event.detail.variant ? event.detail.variant.id : container.getAttribute(selectors.pickupContainer);
    if (event && !event.detail.variant) {
      container.classList.add(classes.isHidden);
      return;
    }

    if (variantID) {
      fetch(`${window.theme.routes.root_url}variants/${variantID}/?section_id=api-pickup-availability`)
        .then(this.handleErrors)
        .then((response) => response.text())
        .then((text) => {
          const pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors.shopifySection).innerHTML;
          container.innerHTML = pickupAvailabilityHTML;
          container.classList.remove(classes.isHidden);

          this.drawer = this.container.querySelector(selectors.drawer);
          this.buttonDrawerOpen = this.container.querySelector(selectors.drawerOpen);
          this.buttonDrawerClose = this.container.querySelectorAll(selectors.drawerClose);
          this.drawerBody = this.container.querySelector(selectors.drawerBody);

          if (this.buttonDrawerOpen) {
            this.buttonDrawerOpen.addEventListener('click', () => this.openDrawer());
          }

          if (this.buttonDrawerClose.length) {
            this.buttonDrawerClose.forEach((element) => {
              element.addEventListener('click', () => this.closeDrawer());
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  openDrawer() {
    if (this.drawer) {
      document.body.classList.add(classes.isPickupVisible);
      this.drawer.classList.add(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
      this.drawerBody.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
    }
  }

  closeDrawer() {
    if (this.drawer) {
      document.body.classList.remove(classes.isPickupVisible);
      this.drawer.classList.remove(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      this.drawerBody.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }
  }

  handleErrors(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          json: json,
        });
        throw e;
      });
    }
    return response;
  }
}

const pickupAvailability = {
  onLoad() {
    sections[this.id] = new PickupAvailability(this);
  },
};

export default pickupAvailability;
